/**
 * Helper function to add new items to subscribers without duplicates
 * Used for optimistic UI updates when owners/assignees are added
 */
export function addToSubscribers(
	currentSubscribers: string[],
	newItems: string[]
): string[] {
	return [...new Set([...currentSubscribers, ...newItems])];
}

/**
 * Helper function to get only the newly added items from an array update
 * Used to determine which items should be optimistically added to subscribers
 */
export function getAddedItems(
	currentItems: string[],
	newItems: string[]
): string[] {
	return newItems.filter((item) => !currentItems.includes(item));
}
